/**
 * Single source of truth for feature flag metadata (shared with CI scripts).
 * Runtime reads live in flags.ts only.
 */

/** @typedef {'boolean' | 'betaOnlyStrapi'} FlagKind */
/** @typedef {'iain' | 'amer' | 'case'} GardenerSeat */

export const ALL_DEPLOY_WORKFLOW_IDS = [
  'dev',
  'dev_mainnet',
  'dev_mainnet_wlth',
  'dev_wlth',
  'preprod',
  'preprod_wlth',
  'prod',
  'prod_wlth',
  'stage',
  'stage_wlth',
]

export const FLAG_REGISTRY_DATA = {
  marketplace: {
    kind: 'boolean',
    env: 'NEXT_PUBLIC_MARKETPLACE_ENABLED',
    default: false,
    owner: 'iain',
    allowedOn: ALL_DEPLOY_WORKFLOW_IDS,
  },
  marketplaceBids: {
    kind: 'boolean',
    env: 'NEXT_PUBLIC_MARKETPLACE_BIDS_ENABLED',
    default: false,
    owner: 'iain',
    allowedOn: ['dev_wlth', 'preprod_wlth', 'prod_wlth'],
  },
  rewards: {
    kind: 'boolean',
    env: 'NEXT_PUBLIC_REWARDS_ENABLED',
    default: false,
    owner: 'iain',
    allowedOn: ALL_DEPLOY_WORKFLOW_IDS,
  },
  betaOnlyStrapi: {
    kind: 'betaOnlyStrapi',
    env: 'NEXT_PUBLIC_BETA_ONLY',
    default: true,
    owner: 'iain',
    allowedOn: [],
  },
  fundWalletPreview: {
    kind: 'boolean',
    env: 'NEXT_PUBLIC_FUND_WALLET_PREVIEW_ENABLED',
    default: false,
    owner: 'iain',
    allowedOn: [],
  },
}

/** Env var names that are feature flags (for lint and workflow checks). */
export const FLAG_ENV_VAR_NAMES = Object.values(FLAG_REGISTRY_DATA).map((def) => def.env)
